import React, { useEffect, useState,useRef } from "react";
import axios from "axios";
import { Table, Pagination, Container, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage, confirmDelete } from "../../components/alert";


// export default function ExamMasterTable() {
//   const [examMasters, setExamMasters] = useState([]);
//   const [page, setPage] = useState(1);
//   const perPage = 10;
//   const [totalPages, setTotalPages] = useState(1);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);



//   const fetchExamMasters = async (pg) => {
//   try {
//     setLoading(true); // start loader
//     const token = localStorage.getItem("token");
//     if (!token) {
//       navigate("/login", { replace: true });
//       return;
//     }

//     const res = await axios.post(
//       "https://codydealms.codydeasoftech.in/api/teacher/fetchExamMaster",
//       {
//         page: String(pg),
//         perpage: String(perPage),
//         searchParam: {
//           search_key: "",
//           program: "",
//           course_category: "",
//           subject: "",
//           semester: ""
//         }
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`
//         }
//       }
//     );

//     if (res.data.status) {
//       setExamMasters(res.data.data.exammasters || []);
//       if (res.data.data.total_records) {
//         setTotalPages(Math.ceil(res.data.data.total_records / perPage));
//       }
//     }
//   } catch (err) {
//     if (err.response && (err.response.status === 401 || err.response.status === 403)) {
//       localStorage.removeItem("token");
//       navigate("/login", { replace: true });
//     } else {
//       console.error("Error fetching exam masters:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load exam master data. Please try again later."
//       });
//     }
//   } finally {
//     setLoading(false); // stop loader
//   }
// };

//   useEffect(() => {
//     fetchExamMasters(page);
//   }, [page]);

//   return (
//     <Container className="mt-3" style={{maxWidth: "1462px"}}>



//       <h4 className="my-4 fw-bold">Exam List</h4>

//        {loading ? (
//       <div className="text-center my-5">
//         <div className="d-flex flex-column align-items-center">
//           <div className="spinner-border text-primary" role="status"></div>
//           <span className="mt-2">Fetching Data...</span>
//         </div>
//       </div>
//       ) : (
//       <div className="card d-flex">
//         <div style={{ overflowX: 'auto', width: '100%', maxWidth: '100vw' }}>
//           <div style={{ minWidth: '900px' }}>


//           <table className="table table-striped table-hover table-responsive">
//             <thead className="table-primary">
//               <tr>
//                 <th>ID</th>
//                 <th>Exam Name</th>
//                 <th>Code</th>
//                 <th>Department</th>
//                 <th>Program</th>
//                 <th>Program Category</th>
//                 <th>Semester</th>
//                 <th>Subject</th>
//                 <th>Exam Paper Type</th>
//               </tr>
//             </thead>

//             <tbody>
//               {examMasters.length > 0 ? (
//                 examMasters.map((exam,index) => (
//                   <tr key={exam.id}>
//                     <td>{index + 1}.</td>
//                     <td>{exam.name}</td>
//                     <td>{exam.code}</td>
//                     <td>{exam.department_name}</td>
//                     <td>
//                       {exam.program_master_code}
//                     </td>
//                     <td>{exam.program_category_name}</td>
//                     <td>{exam.semester_name}</td>
//                     <td>{exam.subject_name}</td>
//                     <td>{exam.exam_paper_type_name}</td>

//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="10" className="text-center">
//                     No records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>




//           </div>
//         </div>
//       </div>

//             )}

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <Pagination className="justify-content-center">
//           <Pagination.Prev
//             onClick={() => setPage((p) => Math.max(p - 1, 1))}
//             disabled={page === 1}
//           />
//           {[...Array(totalPages)].map((_, i) => (
//             <Pagination.Item
//               key={i + 1}
//               active={i + 1 === page}
//               onClick={() => setPage(i + 1)}
//             >
//               {i + 1}
//             </Pagination.Item>
//           ))}
//           <Pagination.Next
//             onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
//             disabled={page === totalPages}
//           />
//         </Pagination>
//       )}


//     </Container>
//   );
// }



export default function ExamMasterTable() {
  const [examMasters, setExamMasters] = useState([]);
  const [page, setPage] = useState(1);
  const perPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Ref to prevent multiple requests
  const isFetching = useRef(false);

  const fetchExamMasters = async (pg) => {
    if (isFetching.current) return; // prevent duplicate calls
    isFetching.current = true;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }

      const res = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchExamMaster",
        {
          page: String(pg),
          perpage: String(perPage),
          searchParam: {
            search_key: "",
            program: "",
            course_category: "",
            subject: "",
            semester: ""
          }
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status) {
        setExamMasters(res.data.data.exammasters || []);
        if (res.data.data.total_records) {
          setTotalPages(Math.ceil(res.data.data.total_records / perPage));
        }
      } else {
        setExamMasters([]);
      }
    } catch (err) {
      if (err.response && (err.response.status === 401 || err.response.status === 403)) {
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
      } else {
        console.error("Error fetching exam masters:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load exam master data. Please try again later."
        });
      }
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  };

  // ✅ Fetch data when page changes
  useEffect(() => {
    fetchExamMasters(page);
  }, [page]);

if (loading) return (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
); 
  return (
  <Container className="mt-3" style={{ maxWidth: "1462px" }}>
    <h4 className="my-4 fw-bold">Exam List</h4>

    <div className="card d-flex">
      <div style={{ overflowX: "auto", width: "100%", maxWidth: "100vw" }}>
        <div style={{ minWidth: "900px" }}>
          <table className="table table-striped table-hover table-responsive">
            <thead className="table-primary">
              <tr>
                <th>ID</th>
                <th>Exam Name</th>
                <th>Code</th>
                <th>Department</th>
                <th>Program</th>
                <th>Program Category</th>
                <th>Semester</th>
                <th>Subject</th>
                <th>Exam Paper Type</th>
              </tr>
            </thead>

            <tbody>
              {examMasters.length > 0 ? (
                examMasters.map((exam, index) => (
                  <tr key={exam.id}>
                    <td>{index + 1}.</td>
                    <td>{exam.name}</td>
                    <td>{exam.code}</td>
                    <td>{exam.department_name}</td>
                    <td>{exam.program_master_code}</td>
                    <td>{exam.program_category_name}</td>
                    <td>{exam.semester_name}</td>
                    <td>{exam.subject_name}</td>
                    <td>{exam.exam_paper_type_name}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Pagination */}
    {totalPages > 1 && (
      <Pagination className="justify-content-center mt-3">
        <Pagination.Prev
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        />
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={i + 1 === page}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
        />
      </Pagination>
    )}
  </Container>
);

}
